import { api as accountingApi } from "../api";
import formUtils from "../../../utils/formUtils";
import {
    Contact,
    ContactCreateParams,
    ContactFormValues,
    ContactGetParams,
    ContactSearchParams,
    ContactSerializedValues,
} from "./types";
import { CollectionResponse } from "../types";

export const serializeFormData = (formData: ContactFormValues): ContactSerializedValues => {
    const { addresses = [], ...rest } = formUtils.sanitizeValues(formData) as ContactFormValues;
    return {
        ...rest,
        vatPayer: !!rest.vatin,
        receivedInvoiceVariableSymbolSetting: "optional",
        addresses: addresses.map((address) => ({
            ...address,
            addressTypes: ["accounting"],
        })),
    };
};

export const contactsApi = accountingApi.injectEndpoints({
    endpoints: (build) => ({
        getContacts: build.query<CollectionResponse<Contact>, ContactSearchParams>({
            query: ({ accountId, ...params }) => ({
                url: `api/v1/accounting/${accountId}/contacts`,
                params,
            }),
            providesTags: ["Contact"],
        }),
        getContact: build.query<Contact, ContactGetParams>({
            query: ({ accountId, contactId }) => ({
                url: `api/v1/accounting/${accountId}/contacts/${contactId}`,
            }),
            providesTags: ["Contact"],
        }),
        createContact: build.mutation<Contact, ContactCreateParams>({
            query: ({ accountId, formData }) => ({
                url: `api/v1/accounting/${accountId}/contacts`,
                method: "POST",
                body: serializeFormData(formData),
            }),
            invalidatesTags: ["Contact"],
        }),
    }),
});

export const { useGetContactsQuery, useGetContactQuery, useCreateContactMutation } = contactsApi;
